import { render, staticRenderFns } from "./hintdetail.vue?vue&type=template&id=489295c7&scoped=true&"
import script from "./hintdetail.vue?vue&type=script&lang=js&"
export * from "./hintdetail.vue?vue&type=script&lang=js&"
import style0 from "./hintdetail.vue?vue&type=style&index=0&id=489295c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489295c7",
  null
  
)

export default component.exports